export const GET_CAMPAÑA = "GET_CAMPAÑA";
export const LOADING_CAMPAÑA = "LOADING_CAMPAÑA";
export const SAVE_LOADER_CAMPAÑA = "SAVE_LOADER_CAMPAÑA";
//PARA Responsable
export const GET_RESPONSABLE = "GET_RESPONSABLE";
export const LOADING_RESPONSABLE = "LOADING_RESPONSABLE";
export const GET_RESPONSABLE_OTRO = "GET_RESPONSABLE_OTRO";
export const LOADING_RESPONSABLE_OTRO = "LOADING_RESPONSABLE_OTRO";
//PARA ENVIO CORREO
export const GET_CORREO = "GET_CORREO";
export const LOADING_CORREO = "LOADING_CORREO";
// Generar usuarios de la campaña
export const GET_SURVEY_CAMPAÑA = "GET_SURVEY_CAMPAÑA";
export const LOADING_SURVEY_CAMPAÑA = "LOADING_SURVEY_CAMPAÑA";
// Generar enlace
export const GET_ENLACE = "GET_ENLACE";
export const LOADING_ENLACE = "LOADING_ENLACE";

export const SEND_SURVEY = "SEND_SURVEY";
